export const apiCreate = (): string => '/warehouse/services/'
export const apiList = (id?: string): string =>
  !id ? '/warehouse/services/' : `/warehouse/services/view/${id}`
export const apiUpdate = (id: string): string =>
  `/warehouse/services/update/${id}`
export const apiDelete = (id: string): string => `/warehouse/services/${id}`
